function NextIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      aria-hidden="true"
      viewBox="0 0 24 24"
    >
      <path
        fill="#7A8086"
        d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
      ></path>
    </svg>
  );
}

export default NextIcon;
